export const blockIconsHomeWindPower = (
	<span className='material-symbols-outlined'>wind_power</span>
);
